
  import { computed, defineComponent, onMounted, ref, watch } from 'vue'
  import DataTable from '@/components/DataTable/index.vue'
  import moment from 'moment'
  import LongText from '@/components/LongText/index.vue'
  import { Button } from '@up.law/uplaw-ui'
  import { CompanyModel, EventAudit } from '@/services/api/models'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from 'vuex'
  import { AuditGetType, AuditStatusType, AuditType } from '@/types'
  import { useI18n } from 'vue-i18n'
  import { TYPE } from 'vue-toastification'
  import Filter from '@/views/Company/audit/filter.vue'
  import EmptyState from '@/components/EmptyState/index.vue'

  export default defineComponent({
    components: { DataTable, LongText, Button, Filter, EmptyState },
    setup() {
      const router = useRouter()
      const route = useRoute()
      const store = useStore()
      const { t } = useI18n()
      const selectedRows = ref<string[]>([])
      const selectedStatus = ref('')
      const isProcessed = ref(false)
      const classes = ref<any>({
        PENDING: 'warning',
        IN_PROGRESS: 'primary',
        DONE: 'success',
        CANCELLED: 'error'
      })
      const data = computed(() => store.getters['organizations/eventAudits'])
      const currentCompany = computed<CompanyModel>(
        () => store.getters['organizations/contextCompany']
      )

      const pagination = ref(store.getters['organizations/auditPagination'])

      const columns = [
        {
          label: t(`datatable.column.date`),
          custom: true,
          field: 'createdAt'
        },
        { label: t(`datatable.column.motive`), custom: true, field: 'motive' },
        {
          label: t(`datatable.column.comment`),
          custom: true,
          field: 'comment'
        },
        {
          label: t(`datatable.column.status`),
          custom: true,
          field: 'processed'
        },
        { label: '', custom: true, field: 'actions', width: '3%' }
      ]
      const auditSelected = (row: string[]) => {
        selectedRows.value = row
      }

      const goToEvent = (data: EventAudit) => {
        router.push({
          name: 'company.eventDetails',
          params: { id: route.params.id, eventId: data.event.id }
        })
      }

      const updateStatus = (status: AuditStatusType) => {
        updateAuditStatus(selectedRows.value, status, AuditGetType.EVENT)
      }

      const updateAuditStatus = (
        ids: string[],
        status: AuditStatusType,
        type: AuditGetType
      ) => {
        store.dispatch('organizations/UPDATE_AUDIT_STATUS', {
          companyId: currentCompany.value.id,
          type,
          data: { auditsId: ids, status },
          onSuccess: () => {
            selectedRows.value = []
            store.dispatch('toolbox/displayToast', {
              type: TYPE.SUCCESS,
              context: t('audits.context'),
              message: t(`audits.editSuccess`)
            })
          },
          onError: () => {
            store.dispatch('toolbox/displayToast', {
              type: TYPE.ERROR,
              context: t('audits.context'),
              message: t(`audits.editError`)
            })
          }
        })
      }

      const markAsProcessed = (data: EventAudit) => {
        const formData = {
          processed: true,
          comment: data.comment,
          motive: data.motive
        }

        store.dispatch('organizations/UPDATE_AUDIT', {
          companyId: currentCompany.value.id,
          type: AuditType.EVENT,
          typeDataId: data.event.id,
          auditId: data.id,
          formData,
          onSuccess: (audit: EventAudit) => {
            console.log()
          },
          onError: () => {
            console.log('ERROR CREATE_AUDIT')
          }
        })
      }

      const onPageChange = (page: number) => {
        getAudits(page)
      }

      const getAudits = (page = 1) => {
        const filter: any = {}
        if (isProcessed.value) filter['isProcessed'] = isProcessed.value
        else delete filter['isProcessed']
        store.commit('organizations/SET_AUDIT_PAGINATION', page)
        store.dispatch('organizations/GET_EVENT_AUDITS', {
          companyId: route.params.id,
          filter,
          onSuccess: (list: any) => {
            pagination.value = {
              total: list.metadata.count,
              currentPage: list.metadata.currentPage,
              lastPage: list.metadata.lastPage,
              limit: 10
            }
          }
        })
      }

      onMounted(() => {
        getAudits()
      })

      watch(isProcessed, () => {
        getAudits()
      })

      return {
        columns,
        moment,
        data,
        pagination,
        selectedStatus,
        classes,
        selectedRows,
        auditSelected,
        updateStatus,
        goToEvent,
        markAsProcessed,
        onPageChange
      }
    }
  })
